import { Injectable } from "@angular/core";
import { AuditLogInput } from "@app/audit-log/models/audit-log-type.model";
import { AuditLogService } from "@app/audit-log/services/audit-log.service";
import { tap } from "rxjs";
import {
    AUTODISCOVERY_METHODS,
    CLARE_HOME_METHODS,
    ClareHomeRPCMethodNames,
    ClareHomeRPCServiceNames,
    EQUATOR_SERVICES_METHODS,
    OAUTH_METHODS,
    UI_METHODS,
} from "../ClareHomeRpc.constants";
import { EquatorProxyService } from "../equator-proxy";
@Injectable({
    providedIn: "root",
})
export class EquatorServicesService {
    constructor(private readonly equatorProxyService: EquatorProxyService, private loggingService: AuditLogService) {}

    // There will be one of these in each equator-*.service class.
    // It supplies the JSON-RPC service name to the proxy.
    // Use this method in each method below.
    private call(uuid, method: ClareHomeRPCMethodNames, params: any[], service?: ClareHomeRPCServiceNames, logInput: AuditLogInput = null) {
        return this.equatorProxyService
            .makeClareHomeRpcRequest$(
                uuid, // uuid
                service || ClareHomeRPCServiceNames.EQUATOR_SERVICES, // service
                method, // method
                params // params
            )
            .pipe(tap(_ => this.saveAuditLog(logInput)));
    }

    public getLiteServiceInfos(uuid: string) {
        return this.call(uuid, UI_METHODS.GET_LITE_SERVICE_INFOS, [], ClareHomeRPCServiceNames.UI_MANAGER);
    }

    public getServiceToDeviceMap(uuid: string) {
        return this.call(uuid, CLARE_HOME_METHODS.GET_SERVICE_TO_DEVICE_MAP, [], ClareHomeRPCServiceNames.CLARE_HOME);
    }

    public updateNameAndZone(uuid: string, instanceId: string, name: string, zoneUids: string[] = []) {
        return this.call(uuid, EQUATOR_SERVICES_METHODS.UPDATE_NAME_AND_ZONE, [instanceId, name, zoneUids]);
    }

    public deleteService(uuid: string, instanceId: string) {
        return this.call(uuid, EQUATOR_SERVICES_METHODS.DELETE_SERVICE, [instanceId]);
    }

    public updateAutoDiscovery(uuid: string, params, logInput: AuditLogInput = null) {
        return this.call(uuid, AUTODISCOVERY_METHODS.ENABLE_DISCOVERY, [params], ClareHomeRPCServiceNames.AUTODISCOVERY, logInput);
    }

    public getDiscoverableDevices(uuid: string) {
        return this.call(uuid, AUTODISCOVERY_METHODS.GET_DISCOVERABLE_DEVICES, [], ClareHomeRPCServiceNames.AUTODISCOVERY);
    }

    public removeOAuthDevice(uuid: string, adapterName: string, logInput: AuditLogInput = null) {
        return this.call(uuid, OAUTH_METHODS.REMOVE_OAUTH_DEVICE, [adapterName], ClareHomeRPCServiceNames.CLARE_HOME, logInput);
    }

    private saveAuditLog(logData: AuditLogInput) {
        if (logData) {
            const { auditName, ...log } = logData;
            if (auditName && log) {
                this.loggingService.logEvent(auditName, log);
            }
        }
    }
}
